import { render } from "./YedionMain.vue?vue&type=template&id=4bbc7014&scoped=true"
import script from "./YedionMain.vue?vue&type=script&lang=js"
export * from "./YedionMain.vue?vue&type=script&lang=js"

import "./YedionMain.vue?vue&type=style&index=0&id=4bbc7014&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bbc7014"]])

export default __exports__